import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import api from "@/lib/api";
import { JournalCard } from "@/components/JournalCard";
import { Loader2 } from "lucide-react";
import * as Icons from "lucide-react";
import { BookOpen } from "lucide-react";

function CategoryIcon({ name, className }) {
  const Ico = Icons[name] || BookOpen;
  return <Ico className={className} />;
}

export default function JournalsIndex() {
  const { settings } = useOutletContext();
  const hideIF = settings?.show_impact_factor === false;
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories").then(({ data }) => setCats(data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="min-h-[50vh] grid place-items-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;

  return (
    <div>
      <div className="bg-primary text-white">
        <div className="max-w-7xl mx-auto px-6 py-14">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-amber-400 font-semibold mb-2">Directory</p>
          <h1 className="font-serif font-black text-4xl md:text-5xl">Our Journals</h1>
          <p className="mt-4 text-slate-300 max-w-2xl">Browse all peer-reviewed open-access journals organised by subject discipline.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16 space-y-14">
        {cats.map((c) => (
          <section key={c.slug} data-testid={`journals-section-${c.slug}`}>
            <div className="flex items-center gap-3 mb-5">
              <span className="grid place-items-center w-10 h-10 rounded-lg bg-primary/5 dark:bg-primary/20 text-primary dark:text-sky-300">
                <CategoryIcon name={c.icon} className="w-5 h-5" />
              </span>
              <h2 className="font-serif font-bold text-2xl text-slate-900 dark:text-slate-100">{c.name}</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {c.journals?.length ? c.journals.map((j) => <JournalCard key={j.slug} journal={j} hideImpactFactor={hideIF} />) : <p className="text-slate-500 text-sm">Coming soon.</p>}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
